import firebase from "../../firebase";

export default function({ name, firstName, lastName, phoneNumber, firstOffice }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "user",
        funcName: "createOffice",
        data: { name, firstName, lastName, phoneNumber, firstOffice }
    });
}
